export default {
  camera: {
    zDist: 20,
    angularSpeed: 0.1,
  },
  bunny: {
    speed: 30,
    angularSpeed: 10,
  },
  exit: {
    dist: 20 //50 + Math.random() * 100
  }
}